import { Transfer } from "antd";
import { useEffect, useState } from "react";

export default function ({ value, onChange, ...otherProps }) {
  const [targetKeys, setTargetKeys] = useState([]);
  const filterOption = (input, option) =>
    (option?.title ?? "").toLowerCase().includes(input.toLowerCase());

  useEffect(() => {
    setTargetKeys(value);
  }, [value]);

  const handleChange = (newTargetKeys) => {
    setTargetKeys(newTargetKeys);
    onChange?.(newTargetKeys);
  };

  return (
    <Transfer
      showSearch
      targetKeys={targetKeys}
      filterOption={filterOption}
      styles={{ section: { minWidth: 300, maxWidth: 300, height: 350 } }}
      onChange={handleChange}
      render={(x) => x.title}
      {...otherProps}
    />
  );
}
